<template>
  <section>  
    <b-row class="match-height">
      <div class="col-md-12 col-lg-12">
        <div class="card">
          <div class="card-header border-bottom">
            <h4 class="card-title">
              Testimonial ({{ testimonials.length }})
            </h4>
            <form>
              <div class="form-group">
                <input
                  v-model="searchParam"
                  name="search"
                  placeholder="Search"
                  class="form-control"
                >
              </div>
            </form>
            <b-button
              v-b-modal.event-modal
              variant="primary"
            >
              Create Testimonial
            </b-button>
          </div>
          <div class="card-datatable">
            <div
              v-if="dataLoading"
              class="overlay"
            >
              Please wait ....
            </div>            
            <table v-else class="datatables-ajax table table-responsive-lg w-100 ">
              <thead>
                <tr>
                  <th>SN</th>
                  <th>Avatar</th>
                  <th>Name</th>
                  <th>Title</th>
                  <th>Message</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tfoot>
                <tr>
                  <th>SN</th>
                  <th>Avatar</th>
                  <th>Name</th>
                  <th>Title</th>
                  <th>Message</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </tfoot>
              <tbody>
                <tr
                  v-for="(testimonial, index) in testimonialList"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>
                    <b-img 
                      :src="testimonial.avatar"
                      width="70"
                    />
                  </td>
                  <td>
                    {{ testimonial.name }}
                  </td>
                  <td>{{ testimonial.title }}</td>
                  <td>{{ testimonial.body }}</td>
                  <td>{{ testimonial.status }}</td>
                  <td>
                    <b-button-group>
                      <b-button
                        v-b-modal.event-edit-modal
                        variant="primary"
                        size="sm"
                        @click="selectTestimonial(testimonial)"
                      >
                      <feather-icon
                        class="mr-25"
                        icon="EditIcon"
                        size="15"
                      />
                      </b-button>
                      <b-button 
                        variant="danger" 
                        size="sm"
                        @click="deleteTestimonial(testimonial)"
                      >
                      <feather-icon
                        class="mr-25"
                        icon="DeleteIcon"
                        size="15"
                      />
                      </b-button>
                    </b-button-group>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </b-row> 
      <nav aria-label="Page navigation">
        <ul class="pagination">
          <li :class="link.active ? 'page-item active' : 'page-item'" v-for="link in meta.links" :key="link.id">
            <a class="page-link" href="javascript:;" @click="paginate(link.url)" v-html="link.label"></a>
          </li>
        </ul>
      </nav>     
    <b-modal
      id="event-modal"
      content-class="shadow"
      title="Create New Event"
      centered
      size="lg"
      no-close-on-backdrop
      hide-footer
    >
      <b-form>
        <b-row>
          <b-col lg="6" md="6">
            <b-form-group
              class="text-primary"
              label="Title"
            >
              <b-form-input
                type="text"
                name="title"
                aria-label="Title"
                v-model="details.title"
                placeholder="Title"
              />
            </b-form-group>
          </b-col>
          <b-col lg="6" md="6">
            <b-form-group
              class="text-primary"
              label="Name"
            >
              <b-form-input
                type="text"
                name="name"
                aria-label="name"
                v-model="details.name"
                placeholder="Name"
              />
            </b-form-group>
          </b-col>
          <b-col lg="12" md="12">
            <b-form-group
              class="text-primary"
              label="Description"
            >
              <b-form-textarea
                name="body"
                aria-label="Description"
                v-model="details.body"
                placeholder="Description"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col lg="6" md="6">
            <b-form-group
              class="text-primary"
              label="Status"
            >
              <b-form-radio-group
                v-model="details.status"
              >
                <b-form-radio value="Published" /> 
                Publish
                <b-form-radio value="Unpublished" /> 
                Draft
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col lg="6" md="6">
            <b-form-group
              class="text-primary"
              label="Avatar"
            >
              <b-form-file
                @change="prepareFile"
                accept=".jpg, .png, .gif"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
              />
            </b-form-group>
          </b-col>
          <b-col md="12" lg="12" class="text-center">
            <b-button variant="primary" size="lg" @click="addTestimonial">
              Save 
              <b-spinner
                variant="white"
                small
                class="ml-1"
                v-show="loading"
              />
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>       
    <b-modal
      id="event-edit-modal"
      content-class="shadow"
      :title="`Edit ${selected.title}`"
      centered
      size="lg"
      no-close-on-backdrop
      hide-footer
    >
      <b-form>
        <b-row>
          <b-col lg="6" md="6">
            <b-form-group
              class="text-primary"
              label="Title"
            >
              <b-form-input
                type="text"
                name="title"
                aria-label="Title"
                v-model="selected.title"
                placeholder="Title"
              />
            </b-form-group>
          </b-col>
          <b-col lg="6" md="6">
            <b-form-group
              class="text-primary"
              label="Name"
            >
              <b-form-input
                type="text"
                name="name"
                aria-label="Name"
                v-model="selected.name"
                placeholder="Name"
              />
            </b-form-group>
          </b-col>

          <b-col lg="12" md="12">
            <b-form-group
              class="text-primary"
              label="Description"
            >
              <b-form-textarea
                name="body"
                aria-label="Description"
                v-model="selected.body"
                placeholder="Description"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col lg="6" md="6">
            <b-form-group
              class="text-primary"
              label="Status"
            >
              <b-form-radio-group
                v-model="selected.status"
              >
                <b-form-radio value="Published" /> 
                Publish
                <b-form-radio value="Unpublished" /> 
                Draft
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col lg="6" md="6">
            <b-img 
              :src="selected.avatar"
              width="100"
            />
            <b-form-group
              class="text-primary"
              label="Change avatar"
            >
              <b-form-file
                @change="prepareFile"
                accept=".jpg, .png, .gif"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
              />
            </b-form-group>
          </b-col>
          <b-col md="12" lg="12" class="text-center">
            <b-button variant="primary" size="lg" @click="editTestimonial">
              Save 
              <b-spinner
                variant="white"
                small
                class="ml-1"
                v-show="loading"
              />
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>       
  </section>
</template>

<script>
import {
  BRow, BMedia, BAvatar, BCard, BCol, BCardBody, 
  BMediaAside, BMediaBody,BCardText, BButtonGroup,
  BButton, BModal, BForm, BFormGroup, BImg, BFormRadioGroup, BFormRadio,
  BFormDatepicker, BFormFile,BFormInput, BFormTextarea, BSpinner,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BSpinner,
    BImg,
    BFormTextarea,
    BFormRadioGroup,
    BFormRadio,
    BFormInput,
    BFormFile,
    BFormDatepicker,
    BButtonGroup,
    BForm,
    BFormGroup,
    BModal,
    BButton,
    BMedia,
    BAvatar,
    BCard,
    BCol,
    BCardBody, BMediaAside, BMediaBody,BCardText,
  },
  data() {
    return {
      form: new FormData(),
      dataLoading: false,
      details: {},
      selected: {},
      data: {},
      testimonials: [],
      meta: {},
      links: {},
      url: '',
      loading: false,
      searchParam: '',
      cancelled_withdrawals: 0,
      failed_withdrawals: 0,
      monthly: 0,
      total_widthrawals: 0,
    }
  },
  computed: {
    testimonialList() {
      return this.testimonials.filter(item => item.title.includes(this.searchParam) || item.title.toLowerCase().includes(this.searchParam))
    },
  },
  mounted() {
    this.url = this.$url+'/testimonials'
    this.getTestimonials()
  },
  methods: {
    prepareFile(event) {
      const files = event.target.files || event.dataTransfer.files
      if (!files.length) return
      this.form.append('avatar', files[0])
    }, 
    deleteTestimonial(item) {
      this.$swal({
        title: `Delete ${item.title} by ${item.name}`,
        html: '<div class=" text-center mt-4"><h4 class="text-danger mb-3">Are you sure you want to delete this ?</h4></div>',
        confirmButtonText: 'Yes, delete it!',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-outline-secondary text-primary ml-1',
        },        
      }).then(result => {
        if (result.value) {
          this.deleteSelected(item.id)
        } 
      })
    },    
    deleteSelected(id) {
      this.$http.delete(`${this.$url}/testimonials/${id}`)
        .then(response => {
          if(response.data.status) {
            this.$swal({
              icon: 'success',
              title: 'Deleted!',
              text: response.data.message,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            .then(res => {
              window.location.reload()
            })
          }
        })
        .catch( err => {
          if(err.response) {
            let message
            if(err.response.status != 200) {
              if(err.response.data.errors) {
                let errors = err.response.data.errors
                let errorList = Object.values(errors)
                errorList.map(msg => {
                    message = msg
                })
              }
              this.$swal({
                title: 'Error',
                text: err.response.data.message || message,
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-secondary',
                },
              })  
            }        
          }          

        })
    },     
    selectTestimonial(item) {
      this.selected = item
    },   
    paginate(url) {
      this.url = url
      this.getTestimonials()
    },  
    editTestimonial() {
      this.loading = true
      this.form.append("title", this.selected.title)
      this.form.append("body", this.selected.body)
      this.form.append("status", this.selected.status)
      this.form.append("name", this.selected.name)
      this.$http.post(`${this.$url}/testimonials/${this.selected.id}`, this.form)
        .then(response => {
          if(response.data.status) {
            this.selected = response.data.data 
            this.$swal({
              icon: 'success',
              title: 'Success!',
              text: response.data.message,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })            
          }
        })
        .catch(err => console.log(err))
        .finally(() => this.loading = false)
    },        
    addTestimonial() {
      this.loading = true
      this.form.append("title", this.details.title)
      this.form.append("body", this.details.body)
      this.form.append("status", this.details.status)
      this.form.append("name", this.details.name)
      this.$http.post(`${this.$url}/testimonials`, this.form)
        .then(response => {
          if(response.data.status) {
            this.testimonials.push(response.data.data) 
            this.$swal({
              icon: 'success',
              title: 'Success!',
              text: response.data.message,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })            
          }
        })
        .catch(err => console.log(err))
        .finally(() => this.loading = false)
    },        
    getTestimonials() {
      this.dataLoading = true
      this.$http.get(`${this.url}`)
        .then(response => {
          if(response.data.status) {
            this.testimonials = response.data.data.data
            this.links = response.data.data.links
            this.meta = response.data.data.meta ?? []
          }
        })
        .finally(() => this.dataLoading = false)
    },
  },
}
</script>

<style lang="scss">
  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0,0,0,.2);
    font-size: 20px;
    color: #fff;
  }
</style>
